exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-contact-js": () => import("./../../../src/pages/contact.js" /* webpackChunkName: "component---src-pages-contact-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-mixes-js": () => import("./../../../src/pages/mixes.js" /* webpackChunkName: "component---src-pages-mixes-js" */),
  "component---src-pages-xyz-js": () => import("./../../../src/pages/xyz.js" /* webpackChunkName: "component---src-pages-xyz-js" */)
}

